import React, { useState, useEffect, JSX, useCallback } from 'react';

import { visas } from 'data';
import { ContinueButton, ComboboxWithConfirm, YearInputWithConfirm } from 'shared-components';

import { Q } from '../../../../../store/student/types';
import { IStudentOtherVisa } from '../../../../../types';
import { validateComplete, validateYear } from './helpers';
import { useTranslation } from "react-i18next";

interface IProps {
  index: number;
  visaType: string;
  year: string;
  onSaveAndClose: (visa: IStudentOtherVisa) => void;
}

const OtherVisas = (props: IProps): JSX.Element => {
    const { t } = useTranslation('common');
  const { index, onSaveAndClose } = props;
  const [visaType, setVisaType] = useState<string>(props.visaType);
  const [year, setYear] = useState<string>(props.year);

  const [complete, setComplete] = useState<boolean>(props.visaType !== '' && props.year !== '');
  const [yearErrorMsg, setYearErrorMsg] = useState<string>('');

  const saveAndCloseCallback = useCallback(() => {
    onSaveAndClose({
      visaType,
      year,
    });
  }, [onSaveAndClose, visaType, year]);

  const handleOnSaveAndCloseClick = (_event: React.MouseEvent<HTMLButtonElement>): void => {
    saveAndCloseCallback();
  };

  useEffect(() => {
    validateComplete(setComplete, visaType, year, yearErrorMsg);
  }, [visaType, year, yearErrorMsg]);

  useEffect(() => {
    if (year.length === 4) {
      validateYear(setYearErrorMsg, year);
    }
  }, [year, validateYear]);

  return (
    <>
      <ComboboxWithConfirm
        key={`${Q.PREV_UK_OTHER_VISA_TYPE}-${index}`}
        id={`${Q.PREV_UK_OTHER_VISA_TYPE}-${index}`}
        label={t('common:whatTypeOfVisaWereYouGranted')}
        isSearchable={true}
        options={visas}
        value={visaType ? [visaType] : []}
        selectProps={{ placeholder: 'Select a visa' }}
        onChange={(newValue: { label: string; value: string }, _meta: unknown) => setVisaType(newValue.value)}
      />

      <YearInputWithConfirm
        key={`${Q.PREV_UK_OTHER_VISA_YEAR}-${index}`}
        id={`${Q.PREV_UK_OTHER_VISA_YEAR}-${index}`}
        value={year}
        label={t('common:whatYearWereYouGrantedThisVisa')}
        onChange={(evt: React.FormEvent<HTMLInputElement>) => setYear(evt.currentTarget.value)}
        maxLength={4}
        errorText={yearErrorMsg}
        placeholder={t('common:yyyy')}
      />

      <ContinueButton index={index} complete={complete} handleOnSaveAndCloseClick={handleOnSaveAndCloseClick} />
    </>
  );
};

export default OtherVisas;
